module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/288_symbol_moneypacket@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/288_symbol_moneypacket@3x.png
// module id = 682
// module chunks = 0